import VuexErrors from 'src/vuex/modules/errors'
import Api from 'fou-api'
import Errors from 'src/utils/helper/errors'

export default {
  namespaced: true,

  state() {
    return {
      isGetStarted: false,
      isReviewed: false,
      signUpApplicationSteps: {
        userId: '',
        message: {},
        applicationStatus: '',
        agreement: {},
        foundry: {},
        designers: {},
        existingDesigners: [],
        predictionScore: ''
      },
      signUpCompleted: false,
      updateSignUpCompleted: false,
      isSuccess: false,
      queries: {
        sortBy: 'updatedAt',
        sortDirection: 'asc',
        perPage: 20
      },
      applications: [],
      count: 0,
      applicationSpinnner: false,
      appInfo: {},
      appStatuses: ['prohibited', 'rejected', 'in_review', 'approved']
    }
  },

  getters: {
    getReviewPage: state => {
      return state.isReviewed
    },
    getStartedStatus: state => {
      return state.isGetStarted
    },
    getSignUpApplicationSteps: state => {
      return state.signUpApplicationSteps
    },
    isSuccessFull: state => {
      return state.isSuccess
    },
    signUpCompleted: state => {
      return state.signUpCompleted
    },
    updateSignUpCompleted: state => {
      return state.updateSignUpCompleted
    },
    applicationsList: state => {
      return state.applications
    },
    applicationsCount: state => {
      return state.count
    },
    queries: state => {
      return state.queries
    },
    applicationLoader: state => {
      return state.applicationSpinnner
    },
    applicationDetails: state => {
      return state.appInfo
    },
    appStatuses: state => {
      return state.appStatuses
    }
  },

  mutations: {
    setReviewPage(state) {
      state.isReviewed = true
    },
    unsetReviewPage(state) {
      state.isReviewed = false
    },
    setIsGetStarted(state) {
      state.isGetStarted = true
    },
    unsetIsGetStarted(state) {
      state.isGetStarted = false
    },
    setSignUpApplicationSteps(state, data) {
      state.signUpApplicationSteps = { ...state.signUpApplicationSteps, ...data }
    },
    setIsSuccess(state) {
      state.isSuccess = true
    },
    unsetIsSuccess(state) {
      state.isSuccess = false
    },
    signUpStart(state) {
      state.signUpCompleted = true
    },
    signUpComplete(state) {
      state.signUpCompleted = false
    },
    updateSignUpStart(state) {
      state.updateSignUpCompleted = true
    },
    updateSignUpComplete(state) {
      state.updateSignUpCompleted = false
    },
    setAll(state, { list = [], options }) {
      if (options.page === 1) {
        state.applications = [...list]
      } else {
        state.applications = [...state.applications, ...list]
      }
    },
    setCount(state, count) {
      state.count = count
    },
    setApplicationSpinner(state, count) {
      state.applicationSpinnner = true
    },
    setApplicationDetails(state, info) {
      state.appInfo = info
    },
    unSetApplicationSpinner(state, count) {
      state.applicationSpinnner = false
    },
    emptyApplications(state) {
      state.applications = []
      state.count = 0
    }
  },

  actions: {
    createNewApplication({ commit, state }, options = {}) {
      commit('signUpStart')
      return new Promise((resolve, reject) => {
        Api.Applications.createApplication(state.signUpApplicationSteps)
          .then(response => {
            if (response?.data) {
              commit('signUpComplete')
              commit('setIsSuccess')
              const application = JSON.stringify(response.data)
              localStorage.setItem('newUser', application)
              return resolve(response.data)
            }
          })
          .catch(error => {
            const err = Errors.create(error)
            commit('errors/add', err)
            commit('signUpComplete')
            reject(err)
          })
      })
    },
    updateApplication({ commit, state }, appId) {
      commit('updateSignUpStart')
      return new Promise((resolve, reject) => {
        Api.Applications.updateUserApplication(appId, state.signUpApplicationSteps)
          .then(response => {
            if (response?.data) {
              commit('updateSignUpComplete')
              resolve(response.data)
            }
          })
          .catch(error => {
            const err = Errors.create(error)
            commit('errors/add', err)
            commit('updateSignUpComplete')
            reject(err)
          })
      })
    },
    updateUserApplicationDS({ commit, state }, userObj) {
      return new Promise((resolve, reject) => {
        Api.Applications.updateUserApplication(userObj.appId, userObj.appData)
          .then(response => {
            if (response?.data) {
              if (userObj.routeName === 'success_signup_status') {
                window.localStorage.setItem('apiFlag', true)
              }
              return resolve(response.data)
            }
          })
          .catch(error => {
            let err = Errors.create(error);
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getApplications({ commit, state }, options = {}) {
      return new Promise((resolve, reject) => {
        Api.Applications.getApplications(
          state.queries.sortBy,
          state.queries.sortDirection,
          options.status,
          options.searchKeyword,
          options.page * 1,
          state.queries.perPage * 1
        )
          .then(response => {
            const list = response.data.collection
            commit('setAll', { list, options })
            const count = response.data.metadata.count
            commit('setCount', count)
            resolve(response.data)
          })
          .catch(error => {
            const err = Errors.create(error)
            commit('errors/add', err)
            reject(err)
          })
      })
    },
    getApplicationByUserID({ commit, state }, userId) {
      commit('setApplicationSpinner')
      return new Promise(resolve => {
        Api.Applications.getApplicationByUserId(userId)
          .then(response => {
            commit('unSetApplicationSpinner')
            commit('setApplicationDetails', response.data)
            window.localStorage.setItem('application_status', response.data.applicationStatus)
            resolve(response.data)
          })
          .catch(error => {
            const err = Errors.create(error)
            commit('unSetApplicationSpinner')
            commit('errors/add', err)
            resolve(err)
          })
      })
    },
    getApplicationByAppID({ commit, state }, appId) {
      commit('setApplicationSpinner')
      return new Promise(resolve => {
        Api.Applications.getApplicationById(appId)
          .then(response => {
            let { userId, applicationStatus, agreement, foundry, designers, existingDesigners, predictionScore } = response.data
            if (response.data.messageHistory) {
              commit('setSignUpApplicationSteps', { messageHistory: response.data.messageHistory })
            }
            commit('setSignUpApplicationSteps', {
              userId,
              applicationStatus,
              agreement,
              foundry,
              designers,
              existingDesigners,
              predictionScore
            })
            commit('setReviewPage')
            commit('unSetApplicationSpinner')
            return resolve(response.data)
          })
          .catch(error => {
            let err = Errors.create(error)
            commit('unSetApplicationSpinner')
            commit('errors/add', err)
            resolve(err)
          })
      })
    }
  },

  modules: {
    errors: VuexErrors
  }
}
